import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MenuContextService } from '../../../features/layout/services/menu-context.service';
import { MenuExpandContextService } from '../../../features/layout/services/menu-expand-context.service';

@Component({
  selector: 'wncm-internal-navigation',
  templateUrl: './internal-navigation.component.html',
  styleUrls: ['./internal-navigation.component.scss']
})
export class InternalNavigationComponent implements OnInit, OnChanges {
  constructor(
    public menuContext$: MenuContextService,
    public menuExpandContext$: MenuExpandContextService,
  ) {
    
  }

  public menuContextValue: any;
  public menuExpandContextValue: any;


  @Input()
	canSeePrevious?: boolean;

  @Input()
	canSeeNext?: boolean;

  @Input()
  previousText?: string;

  @Input()
	nextText?: string;

  @Input()
  nextIconText?: string;

  @Input()
  nextTextValid?: string;

  @Input()
  canNext?: boolean;

  @Output() 
  onPrevious= new EventEmitter<any>();

  @Output() 
  onNext= new EventEmitter<any>();



  ngOnInit(): void {
    this.menuContextValue = this.menuContext$.getValue();
    
  }

  ngOnChanges() {
    if(this.canNext == undefined || this.canNext == null){
      this.canNext = true;
    }
    if(this.previousText == undefined || this.previousText == null){
      this.previousText = "Précédent";
    }

    if(this.nextText == undefined || this.nextText == null){
      this.nextText = "Veuillez remplir toutes les informations"
    }

    if(this.nextTextValid == undefined || this.nextTextValid == null){
      this.nextTextValid = "Suivant"
    }
	}

  goBack(){
    this.onPrevious.emit();
  }

  goNext(){
    this.onNext.emit();
  }

}
